import FlintButton from "@components/controls/FlintButton";
import {FlintIconButtonProps} from "@components/controls/FlintIconButton";
import {VivoPortal} from "@utils/AppConstants";
import FlintIcon from "@components/controls/buttons/FlintIcon";
import {Button} from "@progress/kendo-react-buttons";

export default function BaseActionButton(props: BaseActionButtonProps) {
    const {themeColor = "secondary", type = "button", className, iconEnum, faIcon, spin, disabled, children, ...others} = props;
    const c = props.className ? `action-btn ${props.className}` : "action-btn";

    return (
        <Button className={c} themeColor={disabled == true ? "secondary" : themeColor} type={type}
                disabled={disabled} {...others}>
            <FlintIcon className={"me-2"} iconEnum={iconEnum}/>
            {children}
        </Button>
    )
}

export interface BaseActionButtonProps extends FlintIconButtonProps {
    
}